module.exports = "pegasus/assets/lp/charity/bg1.png";